import React from 'react';
import {Stack} from '@mui/material';
import {Body, designSystemToken} from '@lightricks/react-design-system';
import useLiveEstimatedMinutes from '@contentlab/hooks/use-live-estimated-minutes';
import translate from '@/utils/translate';
import GradientProgressBar from '@/components/gradient-progress-bar';

function AssetProgressBar({
  createdAt,
  estimatedCompletionTime,
}: {
  createdAt: Date;
  estimatedCompletionTime: string | null;
}) {
  const {remainingMinutes, progressPercentage} = useLiveEstimatedMinutes(
    estimatedCompletionTime,
    createdAt
  );

  return (
    <Stack gap="6px" width="100px">
      <Body size="md" textAlign="right">
        {typeof remainingMinutes === 'number'
          ? translate('min left', {
              count: remainingMinutes,
            })
          : translate('Processing')}
      </Body>
      <GradientProgressBar
        value={progressPercentage ?? 0}
        backgroundColor={designSystemToken('semantic.bg.neutral-secondary')}
        fillColor={designSystemToken('semantic.fg.secondary')}
      />
    </Stack>
  );
}

export default AssetProgressBar;
